export class PushResult {
  /** Метки принятых операций */
  accepted: string[]
  rejected: { time: string, error: string }[]

  constructor({ accepted, rejected }: { accepted: string[], rejected: { time: string, error: string }[] }) {
    this.accepted = accepted
    this.rejected = rejected
  }
}
